<template>
  <el-container>
    <el-main style="padding: 0">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 15px;
          width: 100%;
        "
      >
        <div style="width: 400px">
          <!-- <el-autocomplete class="inline-input" style="width: 400px;" size="medium" suffix-icon="el-icon-search" v-model="name" :fetch-suggestions="querySearch"  placeholder="输入角色名称" :trigger-on-focus="false"  @select="handleSelect" @input="inputNothing">
						<template slot-scope="{ item }">
							<div class="name">{{ item.roleName }}</div>
						</template>
					</el-autocomplete> -->
          <el-input
            size="mini"
            placeholder="输入角色名称"
            suffix-icon="el-icon-search"
            v-model="name"
            @input="inputNothing"
            @keyup.enter.native="search"
          ></el-input>
        </div>
        <div>
          <el-button
            type="primary"
            @click="addRol"
            size="mini"
            class="item_font"
            >添加</el-button
          >
        </div>
      </div>
      <div style="width: 100%; margin-top: 20px">
        <el-table
          :data="tableData"
          border
          highlight-current-row
          :header-cell-style="headerStyle"
          :max-height="maxHeight()"
          :cell-style="cellStyle"
          stripe
        >
          <el-table-column type="index" label="编号" width="100">
          </el-table-column>
          <el-table-column property="roleName" label="名称" width="200">
          </el-table-column>
          <el-table-column property="remark" label="备注"> </el-table-column>
          <el-table-column property="operate" label="操作" width="200">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-around;
                "
              >
                <el-button
                  type="text"
                  size="small"
                  @click="addPermission(scope)"
                  class="item_font"
                  >权限设置</el-button
                >
                <el-button
                  @click="edit(scope, tableData[scope.$index])"
                  type="text"
                  size="small"
                  class="item_font"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="delet(scope)"
                  class="item_font"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
    <el-footer>
      <div
        style="
          display: flex;
          flex-direction: row;
          width: 60%;
          margin-left: 20%;
          justify-content: space-around;
        "
      >
        <el-pagination
          background
          :pager-count="9"
          layout="prev, pager, next, total"
          :total="roleTotal"
          @prev-click="pre"
          @next-click="next"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
        <!-- <div>
					<el-button  @click="page('first')">首页</el-button>
				</div>
				<div>
					<el-button icon="el-icon-arrow-left" @click="page('pre')">上一页</el-button>
				</div>
				<div v-for="(item,index) in totalPage" :key="index">
					<el-button @click="page(index)">{{ item }}</el-button>
				</div>
				<div>
					<el-button @click="page('next')">下一页<i class="el-icon-arrow-right el-icon-right"></i></el-button>
				</div>
				<div>
					<el-button  @click="page('end')">尾页</el-button>
				</div> -->
      </div>
    </el-footer>
    <div v-if="addRole == true">
      <el-dialog
        title="添加角色"
        :visible.sync="addRole"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="30%"
        center
      >
        <div style="margin: 0 auto; width: 300px">
          <el-form :model="addForm">
            <el-form-item label="名称:" :label-width="formLabelWidth">
              <el-input
                v-model="addForm.roleName"
                style="width: 220px"
                @keyup.enter.native="nextInput1(2)"
              ></el-input>
              <!-- <el-select v-model="addForm.roleName" placeholder="请选择部门">
								<el-option v-for="(item,index) in tableData" :label="item.roleName" :value="item.roleName" :key="index"></el-option>
								<el-option label="超级管理员" value="超级管理员"></el-option>
								<el-option label="网络管理员" value="网络管理员"></el-option>
								<el-option label="客服管理员" value="客服管理员"></el-option>
								<el-option label="客服" value="客服"></el-option>
							</el-select> -->
            </el-form-item>
            <el-form-item label="备注:" :label-width="formLabelWidth">
              <el-input
                v-model="addForm.remark"
                style="width: 220px"
                @keyup.enter.native="nextInput1(1)"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addRole = false">取 消</el-button>
          <el-button type="primary" @click="condirmAdd('role')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div v-if="editRole == true">
      <el-dialog
        title="编辑角色"
        :visible.sync="editRole"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="30%"
        center
      >
        <div style="margin: 0 auto; width: 300px">
          <el-form :model="editForm">
            <el-form-item label="编号:" :label-width="formLabelWidth">
              <el-input
                v-model="editForm.index"
                style="width: 220px"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="名称:" :label-width="formLabelWidth">
              <el-input
                v-model="editForm.roleName"
                style="width: 220px"
                @keyup.enter.native="nextInput2(3)"
              ></el-input>
              <!-- <el-select v-model="editForm.roleName" placeholder="请选择部门">
								<el-option v-for="(item,index) in tableData" :label="item.roleName" :value="item.roleName" :key="index"></el-option>
								<el-option label="超级管理员" value="超级管理员"></el-option>
								<el-option label="网络管理员" value="网络管理员"></el-option>
								<el-option label="客服管理员" value="客服管理员"></el-option>
								<el-option label="客服" value="客服"></el-option>
							</el-select> -->
            </el-form-item>
            <el-form-item label="备注:" :label-width="formLabelWidth">
              <el-input
                v-model="editForm.remark"
                style="width: 220px"
                @keyup.enter.native="nextInput2(2)"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editRole = false">取 消</el-button>
          <el-button type="primary" @click="confirmEdit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-if="add == true">
      <el-dialog
        title="编辑角色权限"
        :visible.sync="add"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="65%"
        center
      >
        <div style="margin-bottom: 40px; font-size: 16px; font-weight: bold">
          当前设置角色：{{ roleName }}
        </div>
        <el-form :model="form">
          <div style="font-size: 16px; margin-bottom: 20px">拥有权限</div>
          <el-table
            :data="titlePermission"
            style="width: 100%"
            class="rowStyle1"
            :cell-style="cellStyle1"
            :header-cell-style="headerStyle1"
            stripe
            border
            highlight-current-row
          >
            <el-table-column width="160" fixed>
              <template slot="header" slot-scope="scope">
                <div>
                  <template>
                    <!-- <el-form-item @click="cl(scope)"> -->
                    <el-checkbox
                      v-model="valueLst[0]"
                      label="1"
                      @change="checktAll(titlePermission[0], scope.$index)"
                      >{{ titlePermission[0] }}</el-checkbox
                    >
                    <!-- </el-form-item> -->
                  </template>
                </div>
              </template>
              <template slot-scope="scope">
                <div>
                  <div
                    v-for="(item, index) in titlePermission.slice(
                      1,
                      titlePermission.length + 1
                    )"
                    :key="item.id"
                  >
                    <template v-if="scope.$index == index">
                      <!-- <el-form-item> -->
                      <el-checkbox
                        @change="checktAll(item, scope.$index + 1)"
                        v-model="valueLst[scope.$index + 1]"
                        label="1"
                        style="width: 15%"
                        >{{ item }}</el-checkbox
                      >
                      <!-- </el-form-item> -->
                    </template>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header" slot-scope="scope">
                <template @click="cl(scope)">
                  <div class="dq">
                    <el-checkbox
                      v-model="item1.seLect"
                      @change="checkSet(item1, 0)"
                      v-for="item1 in ttPermission[0]"
                      :key="item1.id"
                      style="width: 15%"
                      >{{ item1.name }}</el-checkbox
                    >
                  </div>
                </template>
              </template>
              <template slot-scope="scope">
                <div
                  class="dq"
                  v-for="(item2, index1) in ttPermission.slice(
                    1,
                    ttPermission.length + 1
                  )"
                  :key="index1"
                >
                  <template
                    v-if="
                      scope.$index == index1 &&
                      titlePermission[scope.$index + 1] !== '对话管理'
                    "
                  >
                    <div class="dq">
                      <div>
                        <el-checkbox
                          v-model="item2.seLect"
                          @change="checkSet(item2, index1 + 1)"
                          v-for="item2 in ttPermission[index1 + 1]"
                          :key="item2.id"
                          style="width: 15%"
                          >{{ item2.name }}</el-checkbox
                        >
                      </div>
                    </div>
                  </template>
                  <template
                    v-if="
                      scope.$index == index1 &&
                      titlePermission[scope.$index + 1] === '对话管理'
                    "
                  >
                    <div style="display: flex; flex-direction: column;">
                      <div style="display: flex;flex-wrap:wrap">
                        <el-checkbox
                          v-model="item3.seLect"
                          @change="checkSet(item3, scope.$index + 1)"
                          v-for="(item3, index2) in item2[0].permiList"
                          :key="index2"
                          style="width: 15%"
                          >{{ item3.name }}</el-checkbox
                        >
                      </div>
                      <div style="display: flex;flex-wrap:wrap">
                        <el-checkbox
                          v-model="item3.seLect"
                          @change="checkSet(item3, scope.$index + 1)"
                          v-for="(item3, index2) in item2[1].permiList"
                          :key="index2"
                          style="width: 15%"
                          >{{ item3.name }}</el-checkbox
                        >
                      </div>
                      <!-- <div style="display: flex;flex-direction: row;">
												<div class="dq" >
													<el-checkbox v-model="item3.seLect" @change="checkSet(item3,scope.$index+1)" v-for="(item3,index2) in  item2[0].permiList" :key="index2" style="width: 15%;">{{item3.name}}</el-checkbox>
												</div>
											</div>
											<div style="display: flex;">
											
												<div class="dq" >
													<el-checkbox v-model="item3.seLect" @change="checkSet(item3,scope.$index+1)" v-for="(item3,index2) in  item2[1].permiList" :key="index2" style="width: 15%;">{{item3.name}}</el-checkbox>
												</div>
											</div> -->
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top: 20px">
          <el-button @click="add = false">取 消</el-button>
          <el-button type="primary" @click="condirmAdd('per')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </el-container>
</template>

<script>
import { maxHeight } from "../../utils/tableHeight";
export default {
  name: "RoleSet",
  props: [
    "tableData",
    "permissionLst",
    "titlePermission",
    "textPermission",
    "valueBoo",
    "titleID",
    "roleTotal",
  ],
  mounted() {
    // let self = this
    // 	document.onkeydown = function(e) {
    // 		let ev = document.all ? window.event : e
    // 		if (ev.keyCode === 13) {
    // 			self.handleSelect()
    // 		}
    // 	}
  },
  data() {
    return {
      name: "",
      editRole: false,
      addRole: false,
      add: false,
      scopeIndex: "",
      formLabelWidth: "48px",
      testData: [{ id: 1 }, { id: 1 }, { id: 1 }, { id: 1 }, { id: 1 }],
      addForm: {
        id: null,
        roleName: "",
        remark: "",
      },
      editForm: {
        index: "",
        id: "",
        roleName: "",
        remark: "",
      },
      ttPermission: this.textPermission,
      form: {},
      valueLst: this.valueBoo,
      start: 0,
      roleName: "",
      value: "",
      cur_page: 1,
    };
  },
  watch: {
    textPermission: function (newVal, oldVal) {
      console.log(newVal, oldVal);
      this.ttPermission = newVal;
    },
    valueLst: function (newVal, oldVal) {
      console.log(newVal, oldVal);
      this.valueLst = newVal;
    },
    valueBoo: function (newVal, oldVal) {
      console.log(newVal, oldVal);
      this.valueLst = newVal;
    },
  },
  methods: {
    maxHeight,
    headerStyle({ rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 3) {
        return "text-align:center;color:#000000";
      } else {
        return "text-align:left;padding:15px;color:#000000";
      }
    },
    cellStyle({ columnIndex }) {
      if (columnIndex == 3) {
        return "text-align:center;";
      } else {
        return "text-align:left;padding:15px;";
      }
    },
    rowStyle1() {
      return "height:20px;";
    },
    headerStyle1({ rowIndex, columnIndex }) {
      if (columnIndex == 0 && rowIndex == 0) {
        return "padding-left: 15px;";
      }
    },
    cellStyle1({ columnIndex }) {
      if (columnIndex == 0) {
        return "padding-left: 15px;";
      }
    },
    addPermission(scope) {
      this.add = !this.add;
      this.roleName = this.tableData[scope.$index].roleName;
      this.$emit("addPermission", {
        tableName: "role",
        roleData: this.tableData[scope.$index],
      });
      // for(var i=0;i<this.ttPermission.length;i++){
      // 	var arr=[]
      // 	for(var k=0;k<this.ttPermission[i].length;k++){
      // 		if(this.ttPermission[i][k].seLect===true){
      // 			arr.push(this.ttPermission[i][k].seLect)
      // 			console.log('%%%%%%%%%%%%%%%',arr.length,this.ttPermission[i].length)
      // 			if(arr.length==this.ttPermission[i].length){
      // 				console.log("*******************")
      // 				this.valueLst[i]=true
      // 			}else{
      // 				this.valueLst[i]=false
      // 			}
      // 		}

      // 	}

      // }
    },
    addRol() {
      (this.addForm = { id: null, roleName: "", remark: "" }),
        (this.addRole = !this.addRole);
    },
    edit(scope, form) {
      console.log("角色列表编辑", form);
      this.editForm.index = scope.$index + 1;
      this.editForm.id = form.id;
      this.editForm.roleName = form.roleName;
      this.editForm.remark = form.remark;
      this.scopeIndex = scope.$index;
      console.log(this.editForm);
      this.editRole = true;
    },
    delet(scope) {
      console.log("角色列表删除", scope, this.tableData[scope.$index]);
      this.$emit("delet", {
        tableName: "role",
        editForm: this.tableData[scope.$index],
        page: this.cur_page,
      });
    },
    confirmEdit() {
      console.log("编辑提交", this.editForm);
      if (this.editForm.roleName === "") {
        this.open2(" 不能为空 ");
      } else {
        this.editRole = false;
        this.$emit("confirmEdit", {
          tableName: "roleEdit",
          editForm: this.editForm,
          ind: this.scopeIndex,
          page: this.cur_page,
        });
      }
    },
    condirmAdd(type) {
      if (type === "per") {
        this.add = false;
        console.log(this.ttPermission, this.valueBoo);
        this.$emit("condirmAdd", {
          tableName: "role",
          form: this.ttPermission,
          valueBoo: this.valueBoo,
        });
      } else if (type === "role") {
        console.log(this.addForm);
        if (this.addForm.roleName === "") {
          this.open2(" 不能为空 ");
        } else {
          this.addRole = false;
          this.$emit("confirmEdit", {
            tableName: "roleAdd",
            editForm: this.addForm,
            page: this.cur_page,
          });
        }
      }
    },
    pre(info) {
      console.log("pre：", info);
      this.cur_page = info;
      this.$emit("clickPage", {
        tableName: "role",
        page: info,
      });
    },
    next(info) {
      console.log("next：", info);
      this.cur_page = info;
      this.$emit("clickPage", {
        tableName: "role",
        page: info,
      });
    },
    handleCurrentChange(val) {
      console.log("当前页码：", val);
      this.cur_page = val;
      // this.start = 4*(val-1)
      console.log("当前页码：", val);
      this.$emit("clickPage", {
        tableName: "role",
        page: val,
      });
    },
    querySearch(queryString, cb) {
      var tableData = this.tableData;
      var results = queryString
        ? tableData.filter(this.createFilter(queryString))
        : tableData;
      console.log("查询结果", queryString, results);
      if (results.length == 0) {
        results = [{ roleName: "未搜索到数据" }];
      }
      this.$emit("roleRestart", {
        tableName: "role",
      });
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        return (
          data.roleName.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect() {
      console.log();
      // this.name = item.roleName
      this.$emit("roleSearch", {
        tableName: "role",
        value: this.value,
      });
    },
    inputNothing(val) {
      console.log("输入值发生改变", val);
      this.value = val;
      if (val == "") {
        this.$emit("roleRestart", {
          tableName: "role",
          val: val,
        });
      } else {
        this.$emit("roleSearch", {
          tableName: "role",
          value: this.value,
        });
      }
    },
    checktAll(title, index) {
      console.log("设置全选", title, index, this.ttPermission);
      if (index == 3) {
        console.log("选择我的会话", this.ttPermission[index]);
        for (var i = 0; i < this.ttPermission[index].length; i++) {
          for (
            var k = 0;
            k < this.ttPermission[index][i].permiList.length;
            k++
          ) {
            this.ttPermission[index][i].permiList[k].seLect =
              this.valueLst[index];
          }
        }
        // console.log(44444444444,this.ttPermission[index])
      } else {
        console.log("this.ttPermission[index]", this.ttPermission[index]);
        for (var j = 0; j < this.ttPermission[index].length; j++) {
          this.ttPermission[index][j].seLect = this.valueLst[index];
        }
      }
    },
    checkSet(item, index) {
      console.log("item是什么", index, item, this.ttPermission[index]);
      var arr = [];
      if (item.pid == 19) {
        for (var i = 0; i < this.ttPermission[index].length; i++) {
          var arr1 = this.ttPermission[index][0].permiList.length;
          var arr2 = this.ttPermission[index][1].permiList.length;
          var len = arr1 + arr2;
          for (
            var j = 0;
            j < this.ttPermission[index][i].permiList.length;
            j++
          ) {
            // console.log(7777777777,this.ttPermission[index][i].permiList[j])
            if (this.ttPermission[index][i].permiList[j].seLect === true) {
              arr.push(this.ttPermission[index][i].permiList[j].seLect);
            }
            if (arr.length == len) {
              this.valueLst[index] = true;
            } else {
              this.valueLst[index] = false;
            }
          }
        }
      } else {
        for (var k = 0; k < this.ttPermission[index].length; k++) {
          if (this.ttPermission[index][k].seLect === true) {
            arr.push(this.ttPermission[index][k].seLect);
          }
          if (arr.length == this.ttPermission[index].length) {
            this.valueLst[index] = true;
          } else {
            this.valueLst[index] = false;
          }
        }
      }
    },
    open1() {
      console.log("保存成功");
    },
    open2(info) {
      const text = info + " 保存失败 ";
      this.$message.error(text);
    },
    search(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.handleSelect();
      }
    },
    nextInput1(num) {
      var inputs = document.getElementsByTagName("input");
      inputs[num].focus();
    },
    nextInput2(num) {
      var inputs = document.getElementsByTagName("input");
      inputs[num].focus();
    },
  },
};
</script>

<style>
.opr {
  width: 40px;
  line-height: 20px;
  font-size: 12px;
  color: #35b9ff;
  cursor: pointer;
}
.dq {
  /*		display: flex;
		flex-direction: row;*/
  /* margin-top: 5px; */
  line-height: 20px;
}
.gs {
  width: 140px;
  text-align: right;
}
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
